export default {
    title: "Szállítási visszaigazolás",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Köszönöm",
        message: "Köszönöm a válaszát."
    },
    status: {
        yes: "Kérjük, ellenőrizze az alábbi bejelölt termékeket a kézbesítés megerősítéséhez, és törölje a jelölést a nem kapott termékeknél. Ezután kattintson az Elküldés gombra a megerősítéshez.",
        no: "Kérjük, ellenőrizze, hogy az alábbi termékek egyikét sem kapta-e meg. Ha megkapta-e valamelyiket, kérjük, jelölje be a beérkezett termék(ek) melletti négyzetet, és kattintson a Küldés gombra a megerősítéshez."
    },
    model: {
        checked: {
            label: "Beérkezett"
        }
    },
    button: {
        submit: {
            cta: "Küldés",
            processing: "Beküldés"
        }
    }
}